import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useState } from "react";
import CaseDossier from "components/CaseDossier";
import SearchBar from "components/SearchBar";

const DriveModule = () => {
  const { t } = useTranslation();
  const { filterId } = useParams();
  const [searchText, setSearchText] = useState("");

  const [debouncedText] = useDebounce(searchText, 300);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  // Statyczny filtr "Kosz" (GUID z backendu) — widok usuniętych plików + opróżnianie kosza.
  const KOSZ_FILTER_ID = "5e54d0f3-aae1-4e82-b558-5e72a15dc0ec";
  const isTrashView = (filterId ?? "").toLowerCase() === KOSZ_FILTER_ID;

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.left}>
            <div className={styles.title}>{t("navigation.drive")}</div>
            {isTrashView && (
              <div className={styles.subtitle}>{t("navigation.trash")}</div>
            )}
          </div>
          <div className={styles.right}>
            <SearchBar
              onChange={(t) => handleChangeSearchBar(t)}
              isExpanded={true}
            />
          </div>
        </div>
        <div className={styles.main}>
          <CaseDossier
            Case={null}
            allInOne={true}
            filterId={filterId}
            searchText={debouncedText}
            previewInModal={true}
          ></CaseDossier>
        </div>
      </div>
    </>
  );
};
export default DriveModule;
